module.exports = __webpack_public_path__ + "img/gui_00_landing_1_title_s.4fcf904d.png";